import { useEffect, useRef } from "react";

export default function useScrollReveal() {
  const page = useRef(null);

  useEffect(() => {
    if (!window.IntersectionObserver || window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove("is-pending");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    const sections = page.current.querySelectorAll("[data-reveal]");
    sections.forEach((section) => {
      // Keep content already in view visible; animate sections as they enter below.
      if (section.getBoundingClientRect().top > window.innerHeight) {
        section.classList.add("is-pending");
        observer.observe(section);
      }
    });
    return () => {
      observer.disconnect();
      sections.forEach((section) => section.classList.remove("is-pending"));
    };
  }, []);

  return page;
}
